import { AnalyticsStore, PageStore } from 'bernie-plugin-mobx';
import { inject } from 'mobx-react';
import { useLocation } from 'react-router-dom';
import * as React from 'react';

import { Context } from 'bernie-context';

import { CustomerNotification, CustomerNotificationLocation } from '@shared-ui/customer-notifications';

import { classNames } from 'uitk-react-utils';
import { UitkSpacing } from 'uitk-react-spacing';

import { SimpleLazyLoadWrapper } from 'components/common/lazy/simple-lazy-load-wrapper';

interface CustomerNotificationsProps {
  location: CustomerNotificationLocation;
  page?: PageStore;
  classes?: string;
  regionId?: string;
  startDate?: string;
  endDate?: string;
  context?: Context;
  analytics?: AnalyticsStore;
}

export const CustomerNotifications: React.FC<CustomerNotificationsProps> = inject(
  'page',
  'context'
)(
  React.memo((props: CustomerNotificationsProps) => {
    const { location: notificationLocation, page, classes, regionId, startDate, endDate, context } = props;
    const location = useLocation();

    if (!page || !page.pageId) {
      return null;
    }

    let referer;
    if (context?.site?.domain) {
      const { domain } = context.site;
      const search = location.search || '';
      const path = location.pathname || '';
      referer = `https://${domain}${path}${search}`;
    }

    const customerNotificationsClasses = classes && classNames({ [classes]: classes });
    let customerNotificationInputs;

    if (Number(regionId)) {
      customerNotificationInputs = {
        notificationLocation,
        xPageId: page.pageId,
        optionalContext: {
          journeyCriterias: [
            {
              destination: {
                regionId: regionId,
              },
              dateRange: {
                start: startDate,
                end: endDate,
              },
            },
          ],
        },
      };
    } else {
      customerNotificationInputs = {
        notificationLocation,
        xPageId: page.pageId,
      };
    }

    if (notificationLocation === 'FOOTER') {
      return (
        <UitkSpacing padding={{ blockstart: 'two' }}>
          <div className={customerNotificationsClasses} data-stid={'footer-customer-notification'}>
            <SimpleLazyLoadWrapper>
              <CustomerNotification
                inputs={{
                  xPageId: page.pageId,
                  notificationLocation,
                  optionalContext: {
                    referer,
                  },
                }}
              />
            </SimpleLazyLoadWrapper>
          </div>
        </UitkSpacing>
      );
    }

    return (
      <UitkSpacing padding={{ blockstart: 'two' }}>
        <div className={customerNotificationsClasses}>
          <CustomerNotification
            inputs={customerNotificationInputs as { notificationLocation: typeof notificationLocation; xPageId: string }}
          />
        </div>
      </UitkSpacing>
    );
  })
);
